import React, { useMemo } from "react"
import {
  ActivityIndicator,
  Platform,
  Text,
  TouchableOpacity,
  View,
} from "react-native"
import StyleSheet from "react-native-media-query"

import Base from "../../base"

export default function AppButton({
  colour,
  disabled = false,
  style,
  containerStyle,
  onPress,
  outline,
  dim = false,
  title,
  titleStyle,
  isLoading = false,
  children,
}) {
  const bgColour = useMemo(() => {
    return {
      backgroundColor: outline
        ? "transparent"
        : colour ?? Base.colours.appWhite,
    }
  }, [outline, colour])

  const titleColour = useMemo(() => {
    if (colour) {
      return colour
    }
    return outline ? Base.colours.appWhite : Base.colours.appBrown
  }, [colour, outline])

  const outlineStyle = useMemo(() => {
    return outline
      ? {
          backgroundColor: "transparent",
          borderWidth: 2,
          borderColor: titleColour,
        }
      : {}
  }, [outline, titleColour])

  const opacity = useMemo(() => {
    let _opacity = disabled ? 0.6 : 1.0
    if (dim) {
      _opacity = 0.7
    }
    return _opacity
  }, [disabled, dim])

  return (
    <View
      style={[containerStyle, { opacity }]}
      pointerEvents={disabled ? "none" : "auto"}
    >
      <TouchableOpacity
        activeOpacity={isLoading ? 1.0 : 0.7}
        style={[styles.main, bgColour, outlineStyle, style]}
        onPress={isLoading || onPress}
      >
        {isLoading ? (
          <ActivityIndicator
            size="small"
            color={titleStyle?.color ?? titleColour}
          />
        ) : (
          <Text
            style={[styles.title, { color: titleColour }, titleStyle]}
            dataSet={{ media: ids.title }}
          >
            {title?.replace("\\n", "\n")}
          </Text>
        )}
        {children}
      </TouchableOpacity>
    </View>
  )
}

const { ids, styles } = StyleSheet.create({
  main: {
    width: 220,
    height: 50,
    backgroundColor: Base.colours.appWhite,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 100,
  },

  title: {
    fontFamily: Base.fonts.appTitle,
    fontSize: 30,
    lineHeight: 30,
    textAlign: "center",
    color: Base.colours.appBrown,
    paddingHorizontal: 5,
    marginBottom: Platform.OS === "web" ? 5 : 0,
    "@media (max-width:440px)": {
      fontSize: 26,
      lineHeight: 26,
    },
  },
})
